import PropTypes from 'prop-types';

const propType = {
  bestDay: PropTypes.shape({
    user: PropTypes.shape({ points: PropTypes.number.isRequired }),
    team: PropTypes.shape({ points: PropTypes.number.isRequired }),
  }),
  profile: PropTypes.shape({
    user: PropTypes.number.isRequired,
    team: PropTypes.number.isRequired,
  }),
  trophies: PropTypes.shape({
    user: PropTypes.number.isRequired,
    team: PropTypes.number.isRequired,
  }),
};

export default { propType };
